import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs';

import { ChatMessageBodyComponent } from '@offconon/shared/features/chat/chat-message-body';
import { DesignPanelsHelperService } from '@offconon/shared/utils/services/design-panels-helper';

@Component({
  selector: 'offconon-chat-in-chat-selected',
  imports: [CommonModule, TranslateModule, ChatMessageBodyComponent],
  templateUrl: './chat-in-chat-selected.component.html',
  styles: ``,
})
export class ChatInChatSelectedComponent {
  @Input() parameters: any;
  @Input() selectedBusiness: any;
  @Input() platform = 'core';

  private designPanelsHelperService = inject(DesignPanelsHelperService);

  roomId = toSignal(
    this.designPanelsHelperService.selectedChatRoomId$.pipe(
      filter((roomId): roomId is number => roomId !== undefined),
    ),
  );
}
